import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component(
  {
    templateUrl: './accordion.component.html',
    selector: 'app-accordion',
    styleUrls: ['./accordion.component.scss']
  }
)
export class AccordionComponent implements OnInit {
  public expandedOne = false;
  public expandedTwo = false;
  public expandedThree = false;
  public expandedFour = false;
  public expandedFive = false;
  public expandedSix = false;
  public expandedSeven = false;
  public expandedEight = false;


  private router: Router;

  public constructor(router: Router) 
  {
    this.router = router;
  }

  public ngOnInit(): void 
  {
  }

  public onClickExpand(param: string): void 
  {
    switch (param) {
      case 'one':
        this.expandedOne = this.expandedOne ? false : true;
        this.expandedTwo = false;
        this.expandedThree = false;
        this.expandedFour = false;
        this.expandedFive = false;
        this.expandedSix = false;
        this.expandedSeven = false;
        this.expandedEight = false;
        break;
      case 'two':
        this.expandedOne = false;
        this.expandedTwo = this.expandedTwo ? false : true;
        this.expandedThree = false;
        this.expandedFour = false;
        this.expandedFive = false;
        this.expandedSix = false;
        this.expandedSeven = false;
        this.expandedEight = false;
        break;
      case 'three':
        this.expandedOne = false;
        this.expandedTwo = false;
        this.expandedThree = this.expandedThree ? false : true;
        this.expandedFour = false;
        this.expandedFive = false;
        this.expandedSix = false;
        this.expandedSeven = false;
        this.expandedEight = false;
        break;
      case 'four':
        this.expandedOne = false;
        this.expandedTwo = false;
        this.expandedThree = false;
        this.expandedFour = this.expandedFour ? false : true;
        this.expandedFive = false;
        this.expandedSix = false;
        this.expandedSeven = false;
        this.expandedEight = false;
        break;
        case 'five':
        this.expandedOne = false;
        this.expandedTwo = false;
        this.expandedThree = false;
        this.expandedFour = false;
        this.expandedFive = this.expandedFive ? false : true;
        this.expandedSix = false;
        this.expandedSeven = false;
        this.expandedEight = false;
        break;
      case 'six':
        this.expandedOne = false;
        this.expandedTwo = false;
        this.expandedThree = false;
        this.expandedFour = false;
        this.expandedFive = false;
        this.expandedSix = this.expandedSix ? false : true;
        this.expandedSeven = false;
        this.expandedEight = false;
        break;
      case 'seven':
        this.expandedOne = false;
        this.expandedTwo = false;
        this.expandedThree = false;
        this.expandedFour = false;
        this.expandedFive = false;
        this.expandedSix = false;
        this.expandedSeven = this.expandedSeven ? false : true;
        this.expandedEight = false;
        break;
      case 'eight':
        this.expandedOne = false;
        this.expandedTwo = false;
        this.expandedThree = false;
        this.expandedFour = false;
        this.expandedFive = false;
        this.expandedSix = false;
        this.expandedSeven = false;
        this.expandedEight = this.expandedEight ? false : true;
        break;
    }


  }

  public showPage(path: string): void {
    this.router.navigateByUrl(path);
  }
}
